<script setup lang="ts">
	type passwordValidationDemandsSchema = {
		label: string
		passed: boolean
	}
	const props = defineProps<{
		loading?: boolean
		label?: string
		btnLabel?: string
	}>()
	const formState = ref<{ password: string }>({
		password: ''
	})

	const passwordValidationDemands = ref([
		{
			label: 'Both uppercase and lowercase letters',
			passed: false
		},
		{
			label: 'At least 8-12 characters long',
			passed: false
		},
		{
			label: 'Special characters and numbers',
			passed: false
		}
	])
	const validatePassword = (arg: Array<passwordValidationDemandsSchema>) => {
		arg[0].passed = /[a-z]/.test(formState.value.password) && /[A-Z]/.test(formState.value.password)
		arg[1].passed = formState.value.password.length >= 8
		arg[2].passed =
			/[0-9]/.test(formState.value.password) &&
			/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(formState.value.password)
	}

	const passwordRulePass = computed(() => {
		return passwordValidationDemands.value.every(i => i.passed === true)
	})

	const setPassWord = computed({
		set(val: string) {
			formState.value.password = val
			validatePassword(passwordValidationDemands.value)
		},
		get() {
			return formState.value.password
		}
	})

	const emit = defineEmits<{
		(arg: 'done', param: typeof formState.value): void
	}>()

	const proceed = () => {
		if (passwordRulePass.value && !props.loading) {
			emit('done', formState.value)
		}
	}
</script>

<template>
	<a-form class="w-full" hide-required-mark :model="formState" autocomplete="off" @finish="proceed">
		<a-form-item :label="label || 'Password'" name="password" required>
			<a-input-password
				v-model:value="setPassWord"
				autocomplete="new password"
				data-testid="password"
				class="custom-input w-full !bg-gray-100 !px-5 sm:mb-3"
				placeholder="Enter your password"
			/>
		</a-form-item>

		<div class="mx-auto my-8 flex max-w-[450px] flex-wrap items-center gap-3 sm:my-12 sm:justify-center">
			<div v-for="(item, index) in passwordValidationDemands" :key="index" class="flex items-center gap-2">
				<lazy-tools-icon
					icon="curve-check-2"
					dir="fill"
					:path-class="item.passed ? 'fill-success-500' : 'fill-gray-400'"
				/>
				<span :class="[item.passed ? 'text-success-500' : 'text-gray-400']">
					{{ item.label }}
				</span>
			</div>
		</div>

		<a-button
			class="default-btn mx-auto w-full justify-center bg-primary-2"
			:disabled="!passwordRulePass"
			:loading="loading"
			:data-testid="btnLabel || 'Create Account'"
			@click="proceed"
		>
			{{ btnLabel || 'Create Account' }}
		</a-button>
	</a-form>
</template>
